import { DataTableHead as RWMC, DataTableHeadProps as RWMCProps } from "@rmwc/data-table"
import { HTMLAttributes } from "react"
import omit from "lodash/omit"
import { callCSSFn, CSS, CSSFn, styled, StylePropsWithCSS } from "../../styles"

export type DataTableHeadProps = RWMCProps &
  HTMLAttributes<HTMLTableElement> & {
    css?: CSSFn
  }
const Component = (props: DataTableHeadProps) => <RWMC {...omit(props, `css`)} />
Component.defaultProps = {
  css: undefined,
}
export const DataTableHead = styled(Component)(
  (props: StylePropsWithCSS): CSS => ({
    borderBottom: `1px solid ${props.theme.palette.grey.dark}`,
    ...callCSSFn(props),
  })
)
